// Phase 2.5 — Result panel extracted from GrantAccessModal. Shown after a
// successful grant or re-issue. Surfaces the temp password with a copy
// button so the admin can hand it to the user even if email delivery fails.

import { Btn } from "@/components/Shared";
import { Check, Copy, Mail } from "lucide-react";

export default function GrantResultPanel({
  role,
  result,
  copied,
  onCopy,
  onClose,
}) {
  return (
    <div className="space-y-4" data-testid="grant-result">
      <div className="flex items-start gap-3 p-3 rounded-sm bg-emerald-50 border border-emerald-200 text-[12.5px] text-emerald-900">
        <Check size={16} className="shrink-0 mt-0.5" />
        <div>
          Created <b>{result.user.email}</b> as a <b>{result.user.role}</b>.
          {role === "partner"
            ? <> Linked to partner <b>{result.user.linked_partner_id}</b>.</>
            : <> Linked to merchant <b>{result.user.linked_merchant_name}</b>.</>}
          <br/>
          <span className="text-[11.5px] inline-flex items-center gap-1 mt-1 text-emerald-800/80">
            <Mail size={11} /> Temp password sent to {result.user.email}.
          </span>
        </div>
      </div>
      <div>
        <label className="text-[11px] uppercase text-[var(--muted)] font-semibold tracking-wider">
          Temp password (copy in case email didn't deliver)
        </label>
        <div className="flex items-center gap-2 mt-1">
          <code className="flex-1 px-3 h-10 inline-flex items-center font-mono text-[13px] bg-[var(--surface-2)] border border-[var(--line-2)] rounded-sm select-all" data-testid="grant-temp-password">
            {result.temp_password}
          </code>
          <Btn variant="ghost" onClick={onCopy} testid="grant-copy-password">
            {copied ? <Check size={13} className="text-emerald-600" /> : <Copy size={13} />}
            {copied ? "Copied" : "Copy"}
          </Btn>
        </div>
      </div>
      <div className="flex justify-end pt-2">
        <Btn variant="accent" onClick={onClose} testid="grant-done">Done</Btn>
      </div>
    </div>
  );
}
